import * as React from 'react';
import { SVGProps } from 'react';

const IconMaxWidthSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 2v5.571L5 5v2h6V5l3 2.571V2h2v12h-2V8.429L11 11V9H5v2L2 8.429V14H0V2h2z" />
  </svg>
);
export default IconMaxWidthSizeS;
